export function enableModifiedWarning(isDirtyFn) {
  window.onbeforeunload = function (event) {
    if (!isDirtyFn()) return;
    const confirmationMessage = "Les modifications ne sont pas enregistrées, souhaitez-vous quitter ?";
    event.returnValue = confirmationMessage;
    return confirmationMessage;
  };
}

export function disableModifiedWarning() {
  window.onbeforeunload = null;
}
